import { isProgram, isTopic } from '@tunein/web-common';
import { isPlainObject } from 'es-toolkit';
import { toHttps } from '../../../utils';
function buildAdTargetingParams(nowPlaying) {
    const { classification, primaryGuideId, secondaryGuideId } = nowPlaying;
    const { genreId, contentType, isMatureContent, isFamilyContent, isEvent, isOnDemand, bandId, affiliateIds, } = classification || {};
    const targetingInfo = {
        genre_id: genreId,
        is_mature: isMatureContent,
        is_family: isFamilyContent,
        is_event: isEvent,
        is_ondemand: isOnDemand,
        class: contentType,
        BandId: bandId,
        affiliateIds,
    };
    if (isTopic(secondaryGuideId)) {
        targetingInfo.programId = `${primaryGuideId}, ${secondaryGuideId}`;
    }
    else if (isProgram(primaryGuideId)) {
        targetingInfo.programId = primaryGuideId;
    }
    else {
        targetingInfo.stationId = primaryGuideId;
    }
    if (targetingInfo.programId || targetingInfo.stationId) {
        targetingInfo.ListingId = targetingInfo.programId || targetingInfo.stationId;
    }
    return targetingInfo;
}
export function transformNowPlaying(data, guideId) {
    if (!(data && isPlainObject(data) && (data.secondary || data.primary))) {
        return;
    }
    const { ads, boostPrimary, boostSecondary, classification, containerNavigation, follow, header, popup, primary, secondary, share, switch: switchAction, token, ttl, upsell, } = data;
    const { image: originalImage } = secondary || primary || {};
    const image = toHttps(originalImage || '');
    const primaryGuideId = primary ? primary.guideId : undefined;
    const secondaryGuideId = secondary ? secondary.guideId : undefined;
    const nowPlaying = {
        guideId,
        ads,
        classification,
        header,
        primaryGuideId,
        secondaryGuideId,
        title: header.subtitle,
        subtitle: header.title,
        image,
        followOptions: follow?.options,
        switchAction,
        upsell,
        ttl: ttl * 1000,
        share,
        popup,
        containerNavigation,
        primary: {
            guideId: primary?.guideId,
            title: primary?.subtitle,
            subtitle: primary?.title,
            image: toHttps(primary?.image),
        },
        secondary: {
            title: secondary?.title || primary?.subtitle,
            subtitle: primary?.title,
            image,
        },
        token,
        adTargeting: buildAdTargetingParams({
            classification,
            primaryGuideId,
            secondaryGuideId,
        }),
    };
    if (boostPrimary) {
        nowPlaying.boost = {
            primary: {
                guideId: boostPrimary.guideId,
                title: boostPrimary?.subtitle,
                subtitle: boostPrimary.title,
                image: toHttps(boostPrimary.image),
            },
            secondary: {
                title: boostSecondary?.title || boostPrimary.subtitle,
                subtitle: boostPrimary?.title,
                image: toHttps(boostSecondary?.image || boostPrimary.image),
            },
        };
        nowPlaying.boostImage = nowPlaying.boost?.primary.image;
    }
    return nowPlaying;
}
